import { getStore } from 'core_main/store';
import { DISABLED, ONLINE, OFFLINE, NONE, HIDDEN } from './constants';
import {
  createIsChatAvailableResponse,
  isInBusinessHours,
  isInHoliday,
} from './helpers';
import { IsChatAvailableResponse } from './types';

export const isChatAvailable = (): IsChatAvailableResponse => {
  const store = getStore();

  const { settings, schedule } = store;

  const { enabled, offhoursDisplay } = settings;

  if (!enabled) {
    return createIsChatAvailableResponse(DISABLED);
  }

  const isWithinHoliday = isInHoliday(schedule);

  const isWithinBusinessHours = isInBusinessHours(schedule);
  const isAvailable = isWithinBusinessHours && !isWithinHoliday;

  if (isAvailable || offhoursDisplay === ONLINE) {
    return createIsChatAvailableResponse(ONLINE);
  }

  if (!isAvailable && offhoursDisplay === OFFLINE) {
    return createIsChatAvailableResponse(OFFLINE);
  }

  if (!isAvailable && offhoursDisplay === NONE) {
    return createIsChatAvailableResponse(HIDDEN);
  }

  return createIsChatAvailableResponse(ONLINE);
};
